import Image from 'next/image';
import React from 'react'

const AdvancePayment = ({ deposite }) => {
  return (
    <div className="flex py-2 px-3 sm:mb-5 mb-2 items-center gap-2.5 rounded-md border border-[#BDE3D8] bg-[#E9FAF5]">
      <Image
        src="/icons/ticketList.svg"
        width={20}
        height={20}
        alt="Ticket List"
        className="object-contain"
      />
      <span className="text-xs text-[#347865]">
        %{deposite} şimdi, kalanı girişte öde
      </span>
    </div>
  );
}

export default AdvancePayment